import { Loader } from "@googlemaps/js-api-loader"
import { set } from "../legacy/components/js.cookie/js.cookie";

let max_zoom = 8;
let zoom_offset = {
    left: 0,
    top: 0,
};

const mobile_radius_config = {
    radius_km: 10,
};

function findGeoLocation() {
    return new Promise((resolve, _reject) => {
        if (!navigator.geolocation) {
            resolve(null);
        } else {
            navigator.geolocation.getCurrentPosition((position) => {
                resolve({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                });
            }, () => {
                resolve(null);
            });
        }
    });
}

function findClosestMarker(spherical, markers, position) {
    const closest = markers.reduce((acc, marker) => {
        const distance = spherical.computeDistanceBetween(marker.position, position);
        if (distance < acc.distance) {
            return { marker, distance };
        }
        return acc;
    }, { marker: null, distance: Infinity });

    return closest.marker;
}

function sortStoresAlphabetically(stores) {
    stores.sort((a, b) => {
        return a.title.localeCompare(b.title);
    });
    return stores;
}

function rankStoresByDistance(spherical, stores, position) {
    const ranked = stores.map(store => {
        const distance = spherical.computeDistanceBetween(store.marker.position, position);
        const within_radius = distance < mobile_radius_config.radius_km * 1000;
        return { ...store, distance, within_radius };
    });
    ranked.sort((a, b) => a.distance - b.distance);
    return ranked.map(store => store);
}

function centerZoom(map, positions, do_offset = true) {
    console.log("centerZoom", positions, do_offset);
    const bounds = new google.maps.LatLngBounds();

    const previous_zoom = map.getZoom();

    positions.forEach(pos => {
        bounds.extend(pos);
    });
    map.fitBounds(bounds);

    const current_zoom = map.getZoom();

    if (previous_zoom > max_zoom) {
        console.log("previous_zoom", previous_zoom);
        map.setZoom(previous_zoom);
    } else if (current_zoom > max_zoom) {
        console.log("current_zoom", current_zoom);
        map.setZoom(max_zoom);
    }

    if (do_offset) {
        console.log("panBy", zoom_offset.left, zoom_offset.top);
        setTimeout(() => {
            map.panBy(zoom_offset.left * -1, zoom_offset.top * -1);
        }, 100);
    }
}

function formatKM(distance) {
    // check if NaN or undefined
    if (distance !== distance || distance === undefined) {
        return "";
    }
    if (distance < 1000) {
        return `${Math.round(distance)} m`;
    }
    return `${(distance / 1000).toFixed(1)} km`;
}

export async function registerMap({ apiKey, $map, $form, $places, store_data = [], labels = {} }) {

    // load more on mobile
    document.querySelector("#show-more-places")?.addEventListener("click", event => {
        $places.classList.remove("hide-additional-mobile");
    });
    $places.classList.remove("hide-additional-mobile");

    document.querySelector("html").classList.add("placefinder");

    const mquery = window.matchMedia("(max-width: 768px)");

    mquery.addEventListener("change", handleMediaChange);

    function handleMediaChange(event) {
        if (event.matches) {
            console.log("mobile");
            zoom_offset = {
                left: 0,
                top: 100,
            };
            //document.querySelector('html').style.overflow = "hidden";
            const offset_top = document.querySelector('#places').getBoundingClientRect().top;
            document.querySelector('#places').style.setProperty('--offset-top', `${offset_top}px`);
        } else {
            console.log("desktop");
            zoom_offset = {
                left: 160,
                top: 0,
            };
            document.querySelector('#places').style.setProperty('--offset-top', `${0}px`);
            document.querySelector('html').style.overflow = "scroll";
        }
    }

    handleMediaChange(mquery);

    //document.querySelector('.storefinder-amount-number').textContent = store_data.length;

    const loader = new Loader({
        apiKey,
        version: "weekly",
        ...{},
        language: document.documentElement.lang,
    });


    const { Map } = await loader.importLibrary('maps');
    const { Geocoder } = await google.maps.importLibrary("geocoding");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    const { spherical } = await google.maps.importLibrary("geometry");
    const featureOpts = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#000000"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]}];
    const map = new Map($map, {
        zoom: 8,
        mapId: "c2fd346cb99fa21cc9ee4aac",
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        style: featureOpts,
    });

    function shouldPan($el) {
        return !document.querySelector("#map-ui").classList.contains("empty")
            && $el.classList.contains("gm-control-active");
    }

    let last_zoom = map.getZoom();
    let zoom_direction = 0;

    map.addListener("zoom_changed", () => {
        const current_zoom = map.getZoom();
        zoom_direction = last_zoom < current_zoom ? 1 : -1;
        console.log("zoom_changed", last_zoom, current_zoom, zoom_direction);
        last_zoom = current_zoom;
    });

    $map.addEventListener("click", event => {
        console.log("click map", event.target);
        if (shouldPan(event.target)) {
            console.log("panBy", zoom_offset.left, zoom_offset.top, zoom_direction);
            const zoom_factor = zoom_direction === 1 ? 1 : -1 / 2;
            map.panBy(zoom_offset.left * zoom_factor, zoom_offset.top * zoom_factor);
        }
    });

    const geocoder = new Geocoder();

    let search_marker = null;
    let stores = [];

    const $marker_svg = document.querySelector(".storefinder-marker-default svg");
    const $marker_active_svg = document.querySelector(".storefinder-marker-active svg");

    stores = await Promise.all(store_data.map(async (store) => {
        const marker = new AdvancedMarkerElement({
            map,
            position: store.lat && store.lng ? { lat: store.lat, lng: store.lng } : { lat: 0, lng: 0 },
            title: store.title,
            content: $marker_svg.cloneNode(true),
        });
        marker.addListener("click", () => {
            console.log("click marker", store.title);
            handleSearchMarker(marker, marker.position);
            setTimeout(() => {
                document.querySelector("#map-ui").classList.remove("empty");
                rankStoresByDistance(spherical, stores, marker.position);
                renderStoreList(stores, store.place_id);
            }, 300);
        });
        return { ...store, marker };
    }));

    console.log(stores);

    centerZoom(map, stores.map(({ marker }) => marker.position), mquery.matches);

    function initSearchMarker(position) {
        search_marker = { position };
        // if (search_marker) {
        //     search_marker.position = position;
        // } else {
        //     search_marker = new AdvancedMarkerElement({
        //         map,
        //         position,
        //         title: "You are here",
        //         content: pin.element,
        //     });
        // }
    }

    function resetSearchMarker() {
        if (search_marker) {
            //search_marker.setMap(null);
            search_marker = null;
        }
    }

    stores = sortStoresAlphabetically(stores);
    renderStoreList(stores, "no-place-id");

    async function handleGeoLocation() {
        const location = await findGeoLocation();
        if (!location) {
            return;
        }
        console.log("location provided", location);
        document.querySelector("#map-ui").classList.remove("empty");
        initSearchMarker(location);
        geocoder.geocode({ location }, (results, status) => {
            if (status == 'OK') {
                $form.elements.address.value = results[0].formatted_address;
            } else {
                console.warn('Geocode was not successful for the following reason: ' + status);
            }
        });
        const closest = findClosestMarker(spherical, stores.map(({ marker }) => marker), search_marker.position);
        handleSearchMarker(closest, location);
        renderStoreList(stores);
    }

    handleGeoLocation();

    function handleSearchMarker(selected_marker, location) {
        console.log("handleSearchMarker selected", selected_marker.title);
        if (!location) {
            centerZoom(map, [
                selected_marker.position,
            ]);
            return;
        }

        stores = rankStoresByDistance(spherical, stores, location);

        centerZoom(map, [
            //search_marker.position,
            selected_marker.position,
        ]);
    }

    function renderStoreList(stores, place_id = null) {
        console.log("renderStoreList", stores, place_id);
        $places.innerHTML = "";
        stores.forEach(store => {
            const $li = document.createElement("li");
            if (store.within_radius) {
                $li.classList.add("within-radius");
            }
            const $title_row = document.createElement("div");
            $title_row.classList.add("title-row");
            $li.appendChild($title_row);

            const $p = document.createElement("p");
            $p.textContent = store.title;
            $p.classList.add("store-title");
            $title_row.appendChild($p);

            const $distance = document.createElement("span");
            const distance_in_km = formatKM(store.distance);
            const distance_text = document.createTextNode(distance_in_km);
            $distance.appendChild(distance_text);
            $distance.classList.add("store-distance");
            $title_row.appendChild($distance);

            const $details = document.createElement("div");
            //const opening_hours = currentOpeningHours(store.place);
            const lang = document.documentElement.lang.split("-")[0];
            const display_address = store.address.split(';').filter(element => true).join('<br>');
            $details.innerHTML = /* html */`
                <div class="place-address">${display_address}</div>
                <div class="place-infos-button" data-fridge-id="${store.id}"><button class="btn btn-info">${labels['Infos']}</button></div>
            `;

            $details.classList.add("details");
            $li.appendChild($details);
            $places.appendChild($li);

            store.marker.content = $marker_svg.cloneNode(true);
            store.marker.zIndex = 0;
            //console.log("check store", place_id, store.place_id, store.title)
            if (place_id && store.place_id === place_id) {
                console.log("selected", store.title)
                $li.classList.add("selected");
                store.marker.content = $marker_active_svg.cloneNode(true);
                store.marker.zIndex = 1000;
            }

            $li.addEventListener("click", event => {
                // return if any link or button was clicked
                if (event.target.closest("a") || event.target.closest("button")) {
                    //return;
                }

                if (mquery.matches) {
                    // click the button
                    $li.querySelector(".place-infos-button button")?.click();
                }

                $places.querySelectorAll("li").forEach($li => $li.classList.remove("selected"));
                $li.classList.add("selected");
                stores.forEach(store => {
                    store.marker.content = $marker_svg.cloneNode(true);
                    store.marker.zIndex = 0;
                });
                store.marker.content = $marker_active_svg.cloneNode(true);
                store.marker.zIndex = 1000;
                handleSearchMarker(store.marker, search_marker?.position);
            });
        });

        // add li at the end with the text "Alle Standorte"
        const $li = document.createElement("li");
        $li.classList.add("all-places");
        const $button = document.createElement("button");
        $button.classList.add("btn", "btn-info");
        $button.type = "button";
        $button.setAttribute("aria-label", "Booking");
        const $div = document.createElement("div");
        $div.textContent = "Alle Standorte";
        $button.appendChild($div);
        $li.appendChild($button);
        $button.addEventListener("click", event => {
            window.scrollToNextSection();
        });
        $places.appendChild($li);

        if (place_id === null && $places.querySelector("li")) {
            $places.querySelector("li").classList.add("selected");
            stores[0].marker.content = $marker_active_svg.cloneNode(true);
            stores[0].marker.zIndex = 1000;
        }

        $places.querySelector(".selected")?.scrollIntoView({ behavior: "smooth", block: "nearest" });

        //$places.classList.add("hide-additional-mobile");
    }

    $form.addEventListener("submit", event => {
        event.preventDefault();

        if ($form.elements.address.value === "") {
            console.log("Empty search");
            resetSearchMarker();
            stores.forEach(store => {
                store.marker.content = $marker_svg.cloneNode(true);
                store.marker.zIndex = 0;
            });
            centerZoom(map, stores.map(({ marker }) => marker.position));
            if (!is_booking) {
                return;
            } else {
                stores = sortStoresAlphabetically(stores);
                renderStoreList(stores);
                return;
            }
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'event': 'pos_search', 'searchterm': $form.elements.address.value});

        const address = $form.elements.address.value + " Switzerland";
        console.log("Search for", address);

        geocoder.geocode({ address }, (results, status) => {
            if (status == 'OK') {
                initSearchMarker(results[0].geometry.location);
                const closest = findClosestMarker(spherical, stores.map(({ marker }) => marker), search_marker.position);
                handleSearchMarker(closest, search_marker.position);
                renderStoreList(stores);
            } else {
                console.warn('Geocode was not successful for the following reason: ' + status);
            }
        });

        document.querySelector("#map-ui").classList.remove("empty");
    });

    $form.addEventListener("reset", event => {
        document.querySelector("#map-ui").classList.add("empty");
        event.preventDefault();
        $form.elements.address.value = "";
        stores = sortStoresAlphabetically(stores);
        resetSearchMarker();
        renderStoreList(stores);
        stores.forEach(store => {
            store.marker.content = $marker_svg.cloneNode(true);
            store.marker.zIndex = 0;
        });
        centerZoom(map, stores.map(({ marker }) => marker.position), mquery.matches);
    });

    document.querySelectorAll("#place-finder-suggestions button").forEach($a => {
        $a.addEventListener("click", event => {
            event.preventDefault();
            const searchSuggestion = $a.textContent;
            $form.elements.address.value = searchSuggestion;
            // const isDispatched = $form.dispatchEvent(new Event("submit"), { bubbles: true, cancelable: true });
            // console.log("Form dispatched:", isDispatched);
            $form.requestSubmit();
        });
    });
}


export async function findPlaces(Place, textQuery) {
    return await Place.searchByText({
        textQuery,
        fields: ["displayName", "formattedAddress", "location"],
        useStrictTypeFiltering: false,
    });
}

export async function getPlaceDetails(id) {

    // if (place_details_cache[id]) {
    //     console.log("place details cache hit", id);
    //     return place_details_cache[id];
    // } else {
    //     console.log("place details cache miss", id);
    // }

    const { Place } = await google.maps.importLibrary("places");
    const lang = document.documentElement.lang.split("-")[0];
    const place = new Place({
        id,
        requestedLanguage: lang,
    });

    const place_fields = await place.fetchFields({
        fields: [
            "displayName",
            "formattedAddress",
            "location",
            // "regularOpeningHours",
            // "nationalPhoneNumber"
        ],
    });

    // window.places_cache = window.places_cache || {};
    // window.places_cache[id] = place_fields;

    return place_fields;
}

// generates a dom node with a list of opening hours for a place id
// export async function renderOpeningHours($root = document, apiKey, id) {
//     const loader = new Loader({
//         apiKey,
//         version: "weekly",
//         ...{},
//         language: document.documentElement.lang,
//     });
//     const { Place } = await loader.importLibrary("places");
//     const lang = document.documentElement.lang.split("-")[0];
//     const place = new Place({
//         id,
//         requestedLanguage: lang,
//     });

//     const details = await place.fetchFields({
//         fields: [
//             "displayName",
//             "formattedAddress",
//             "location",
//             "regularOpeningHours",
//             "nationalPhoneNumber"
//         ],
//     });

//     const $details = document.createElement("ol");
//     $details.classList.add("details");

//     details.place.regularOpeningHours.weekdayDescriptions.forEach((opening_hours) => {
//         const $li = document.createElement("li");
//         $li.textContent = opening_hours;
//         $details.appendChild($li);
//     });

//     $root.appendChild($details);
// }